import { jsx } from "react/jsx-runtime";
import { Root } from "../node_modules/.pnpm/@radix-ui_react-label@2.1.7_@types_react-dom@18.3.7_@types_react@18.3.25__@types_react@_16fd21d049a89d814df3ae4efeb87383/node_modules/@radix-ui/react-label/dist/index.js";
import { cva } from "../node_modules/.pnpm/class-variance-authority@0.7.1/node_modules/class-variance-authority/dist/index.js";
import * as React from "react";
import { cn } from "../lib/utils.js";
const labelVariants = cva(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
);
const Label = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  Root,
  {
    ref,
    className: cn(labelVariants(), className),
    ...props
  }
));
Label.displayName = Root.displayName;
export {
  Label
};
//# sourceMappingURL=label.js.map
